const getDefaultState = () => {
  return {
    ParcoursEffectif: [],
    ParcoursEffectifsDuGroupe: [],
    ParcoursEffectifById: [],
    //field: "name",
    whereField: "id_responsable",
    //whereValue: "superviseur",
    collection: "parcours_effectif",
  };
};
const state = getDefaultState();

const mutations = {
  SET_ITEM_BY_ID(state, payload) {
    state.ParcoursEffectifById = payload;
  },
  SET_LISTE(state, payload) {
    state.ParcoursEffectif = payload;
  },
  SET_PARCOURS_DU_GROUPE(state, payload) {
    state.ParcoursEffectifsDuGroupe = payload;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },

  ADD_ONE_ITEM(state, payload) {
    state.ParcoursEffectif.push(payload);
    //state.ParcoursEffectifsDuGroupe.push(payload);
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  addOneItem({ commit }, item) {
    commit("ADD_ONE_ITEM", item);
    console.log("added to Vuex Parcours", item)
  },
  async GetSuperviseurParcoursEffectif({ commit, dispatch }, objet) {
    // start requête
    var start = this._vm
      .$moment(Date.now())
      .subtract(3, "months")
      .format("YYYY-MM-DD");
    var end = this._vm
      .$moment(Date.now())
      .add(3, "days")
      .format("YYYY-MM-DD HH:mm:ss");

    commit("SET_LISTE", []);

    commit(
      "Loading/START_BUSY_STATE",
      "ParcoursEffectif GetSuperviseurParcoursEffectif",
      {
        root: true,
      }
    );

    let elemsTemp = [];

    await this._vm.$firebase
      .firestore()
      .collection("parcours_effectif")
      .where("id_responsable", "==", objet.userId)
      .where("programmes_id_programme", "==", objet.project.id)
      .where("ll_mois", ">=", start)
      .where("ll_mois", "<=", end)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          elemsTemp.push({
            ...doc.data(),
            id: doc.id,
          });
        });
      });

    commit("SET_LISTE", elemsTemp);
    commit(
      "Loading/END_BUSY_STATE",
      "ParcoursEffectif.store.js GetSuperviseurParcoursEffectif",
      {
        root: true,
      }
    );
  },
  async GetParcoursEffectifsDuGroupe({ commit, dispatch }, idGroupe) {
    // start requête
    commit("SET_PARCOURS_DU_GROUPE", []);
    commit(
      "Loading/START_BUSY_STATE",
      "ParcoursEffectif GetParcoursEffectifsDuGroupe",
      {
        root: true,
      }
    );
    let elems = [];
    await this._vm.$firebase
      .firestore()
      .collection(this.state.ParcoursEffectif.collection)
      .where("groupes_id_groupe", "==", idGroupe)
      .orderBy("ll_programme")
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            console.log("No Data Available");
            return false;
          } else {
            commit("SET_PARCOURS_DU_GROUPE", elems);
            commit("Loading/END_BUSY_STATE", "ParcoursEffectif.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
          commit("Loading/END_BUSY_STATE", "ParcoursEffectif.store.js", {
            root: true,
          });
        }
      );
  },
  async GetParcoursEffectifById({ commit }, idparcoursEffectif) {
    commit("Loading/START_BUSY_STATE", "GetParcoursEffectifById", {
      root: true,
    });
    var docRef = await this._vm.$firebase
      .firestore()
      .collection("parcours_effectif")
      .doc(idparcoursEffectif);
    docRef
      .get()
      .then(function (doc) {
        if (doc.exists) {
          //console.log("Document data:", doc.data());
          commit("SET_ITEM_BY_ID", doc.data());
          commit("Loading/END_BUSY_STATE", "GetParcoursEffectifById", {
            root: true,
          });
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch(function (error) {
        console.log("Error getting document:", error);
      });
  },
};

const getters = {
  ParcoursEffectif: (state) => {
    return state.ParcoursEffectif;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
